<form (formValueChange)="formValue.set($event)" (submit)="handleFormSubmit()">
  @switch (vm.currentStep) {
    @case ('model-number') {
      <app-appliance-details
        ngModelGroup="model-number"
        #applianceDetailsComponent
        [formValue]="vm.formValue['model-number']"
        (formValid)="formValid.set($event)"
        [formSubmitted]="vm.stageSubmitted"
        [confirmBlankModelNumber]="confirmBlankModelNumber"
      />
    }

    @case ('product-number') {
      <app-product-number-code
        ngModelGroup="product-number"
        [formValue]="vm.formValue['product-number']"
        (formValid)="formValid.set($event)"
        [formSubmitted]="vm.stageSubmitted"
      />
    }

    @case ('fault-details') {
      <app-fault-details
        #faultDetailsComponent
        ngModelGroup="fault-details"
        [formValue]="vm.formValue['fault-details']"
        [formSubmitted]="vm.stageSubmitted"
        (formValid)="formValid.set($event)"
      />
    }

    @case ('repair-details') {
      <app-orbit-qa-flow
        #orbitQaFlowComponent
        ngModelGroup="repair-details"
        [formValue]="vm.formValue['repair-details']"
        [formSubmitted]="vm.stageSubmitted"
        (formValid)="formValid.set($event)"
      />
    }

    @case ('confirm-your-details') {
      <app-confirm-your-details
        ngModelGroup="confirm-your-details"
        [formValue]="vm.formValue['confirm-your-details']"
        (formValid)="formValid.set($event)"
      />
    }

    @case ('service-options') {
      <app-service-options
        ngModelGroup="service-options"
        [formValue]="vm.formValue['service-options']"
        [formSubmitted]="vm.stageSubmitted"
        (formValid)="formValid.set($event)"
      />
    }

    @case ('payment') {
      <app-payment-form />
    }

    @case ('book-engineer') {
      <app-book-engineer
        #bookEngineerComponent
        [formValue]="vm.formValue['book-engineer']"
        [formSubmitted]="vm.stageSubmitted"
        (formValid)="formValid.set($event)"
        ngModelGroup="book-engineer"
        (appointmentDataChange)="setAppointmentData($event)"
        (initialAppointmentDataChange)="setAppointmentData($event)"
        (dateChange)="setDate($event)"
      />
    }

    @case ('book-collection') {
      <app-book-collection
        #bookCollectionComponent
        [formValue]="vm.formValue['book-collection']"
        [formSubmitted]="vm.stageSubmitted"
        (formValid)="formValid.set($event)"
        ngModelGroup="book-collection"
      />
    }

    @default {
      Not setup yet!
    }
  }
  <!--  {{ vm.formValue | json }}-->

  @if (vm.showActionSection) {
    <section class="actions flex gap-8 full-width">
      @if (vm.showBackButton) {
        <app-button
          dataLabel="back-button"
          class="min-w-160"
          [buttonOptions]="{
            variant: 'secondary',
          }"
          (click)="goBack()"
        >
          <i class="fa-light fa-arrow-left mr-8"></i>
          Back
        </app-button>
      }

      <div class="continue-section flex gap-8">
        <app-button
          dataLabel="continue-button"
          [buttonOptions]="{
            type: 'submit',
            disabled: vm.loadingData || vm.submittingValue,
          }"
          [loading]="vm.submittingValue || vm.loadingData"
          class="min-w-160"
          (click)="handleContinueClicked()"
        >
          {{ continueLabelText }}
          @if (showContinueArrow) {
            <i class="fa-light fa-arrow-right ml-8"></i>
          }
        </app-button>
      </div>
    </section>
  }
</form>
